import { Link } from '@inertiajs/react'
import { CheckCircle, Clock } from 'lucide-react'
import { UserSidebar } from '@/components/layout/UserSidebar'

interface HistoryItem {
  episode: { id: number; title: string; slug: string; duration: string; thumbnail_url: string | null }
  position: number
  completed: boolean
  percentage: number
  watched_at: string
}

export default function Index({ history }: { history: HistoryItem[] }) {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <UserSidebar active="/history" />
      <main className="flex-1 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Watch History</h1>

        {history.length === 0 ? (
          <div className="text-center py-20 text-gray-400">
            <p className="mb-3">You haven't watched anything yet.</p>
            <Link href="/episodes" className="text-brand hover:underline">Browse episodes →</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {history.map((item, i) => (
              <Link
                key={i}
                href={`/episodes/${item.episode.slug}`}
                className="flex items-center gap-4 bg-white rounded-xl border border-gray-100 p-4 hover:border-brand/30 hover:shadow-sm transition-all"
              >
                {/* Thumbnail */}
                <div className="w-24 aspect-video bg-gray-800 rounded-lg shrink-0 overflow-hidden">
                  {item.episode.thumbnail_url && (
                    <img src={item.episode.thumbnail_url} alt="" className="w-full h-full object-cover" />
                  )}
                </div>
                {/* Info */}
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-gray-900 text-sm truncate">{item.episode.title}</p>
                  <div className="flex items-center gap-2 mt-1">
                    {item.completed ? (
                      <span className="flex items-center gap-1 text-xs text-green-600">
                        <CheckCircle className="w-3.5 h-3.5" /> Completed
                      </span>
                    ) : (
                      <span className="flex items-center gap-1 text-xs text-gray-400">
                        <Clock className="w-3.5 h-3.5" /> {item.percentage}% watched
                      </span>
                    )}
                    <span className="text-xs text-gray-300">·</span>
                    <span className="text-xs text-gray-400">{item.episode.duration}</span>
                  </div>
                  {/* Progress bar */}
                  <div className="mt-2 w-full bg-gray-100 rounded-full h-1">
                    <div className="bg-brand h-1 rounded-full" style={{ width: `${item.percentage}%` }} />
                  </div>
                </div>
                {/* Date */}
                <div className="text-xs text-gray-400 shrink-0">
                  {new Date(item.watched_at).toLocaleDateString()}
                </div>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  )
}
